export const IndustryTabsData = [
  "Healthcare",
  "Fintech",
  "E-commerce & Retail",
  "Real Estate",
  "Automotive",
  "Education",
  "Insurance",
  "Logistics",
  "Entertainment",
  "Gaming",
  "Social Networking",
  "Telecom",
  "Energy",
];

export const IndustryTabsItemsData = [
  {
    tabName: "Healthcare",
    tabDes:
      "Mobile app development has revolutionized the healthcare sector, streamlining processes & improving patient experiences. We specialize in creating custom mobile apps that ensure secure data handling, user-friendly designs, & efficient performance. Whether it’s iOS, android, or cross-platform apps, our solutions empower healthcare providers with seamless communication, remote consultations, & advanced patient management.",
    objectives: [
      "Custom mobile apps tailored to healthcare needs.",
      "iOS, android, & cross-platform app development.",
      "Innovative solutions for better patient care.",
    ],
    href: "/industries/healthcare",
    tabImage: "health-care-image.png",
  },
  {
    tabName: "Fintech",
    tabDes:
      "Fintech is transforming how the world manages money, & we’re here to lead the charge. From secure payment gateways to streamlined financial tools, our apps are designed to empower businesses & elevate user experiences. With our expertise, finance becomes more accessible, efficient, & future-ready.",
    objectives: [
      "Revolutionizing financial processes with technology.",
      "Crafting tools for seamless transactions & management.",
      "Driving innovation to simplify complex financial systems.",
    ],
    href: "/industries/fintech",
    tabImage: "Fintech.png"
  },
  {
    tabName: "E-commerce & Retail",
    tabDes:
      "In a world where convenience is key, our E-commerce & Retail apps set the standard. We build immersive shopping experiences, empowering businesses to connect with their customers in meaningful ways. Whether it’s managing inventory or enhancing user journeys, we bring ideas to life with unmatched precision.",
    objectives: [
      "Creating memorable shopping journeys.",
      "Boosting customer loyalty through innovation.",
      "Tailored solutions for every retail challenge.",
    ],
    href: "/industries/retail-ecommerce",
    tabImage: "Retail-ecommerce.png"
  },
  {
    tabName: "Real Estate",
    tabDes:
      "Real estate isn’t just about properties; it’s about connections. Our apps redefine how buyers, sellers, & agents interact. From virtual tours to instant updates, we bridge the gap between dreams & reality. Let technology unlock the potential of your real estate business.",
    objectives: [
      "Bringing properties to life through innovation.",
      "Empowering seamless communication & exploration.",
      "Tailored tools for a dynamic market.",
    ],
    href: "/industries/real-estate",
    tabImage: "Realestate.png"
  },
  {
    tabName: "Automotive",
    tabDes:
      "Driving innovation in the automotive world, our apps put control at your fingertips. From vehicle tracking to service reminders, we enhance the way businesses operate & customers engage. The road to efficiency & satisfaction starts with us.",
    objectives: [
      "Revolutionizing vehicle management & engagement.",
      "Designed for dealerships, fleet managers, & users alike.",
      "Streamlining automotive operations with ease.",
    ],
    href: "/industries/automotive",
    tabImage: "automotive.png"
  },
  {
    tabName: "Education",
    tabDes:
      "Education is evolving, & so are the tools that power it. Our apps make learning exciting, accessible, & impactful. Whether it’s personalized courses or dynamic tools for teachers, we empower institutions to inspire & engage the next generation.",
    objectives: [
      "Transforming learning experiences for all.",
      "Making education interactive & inclusive.",
      "Building platforms that inspire growth & discovery.",
    ],
    href: "/industries/education",
    tabImage: "education.png"
  },
  {
    tabName: "Insurance",
    tabDes:
      "Insurance doesn’t have to be complicated. Our apps simplify claims, policies, & communication, making every process seamless. With security & accessibility at the forefront, we help businesses deliver peace of mind to their clients.",
    objectives: [
      "Simplifying every aspect of the insurance journey.",
      "Building trust through secure, user-friendly solutions.",
      "Bridging the gap between clients & services.",
    ],
    href: "/industries/insurance",
    tabImage: "Insurance.png"
  },
  {
    tabName: "Logistics",
    tabDes:
      "Speed, precision, & reliability – our logistics apps are built to deliver. Whether tracking shipments, managing fleets, or improving inventory systems, we create tools that keep businesses moving efficiently. Every delivery, perfectly timed & executed.",
    objectives: [
      "Optimizing supply chains with real-time solutions.",
      "Enhancing delivery systems for smoother operations.",
      "Empowering businesses to stay ahead in logistics.",
    ],
    href: "/industries/logistics",
    tabImage: "logistics.avif"
  },
  {
    tabName: "Entertainment",
    tabDes:
      "Entertainment apps should do more than deliver content; they should create experiences. From immersive streaming platforms to engaging multimedia tools, we design apps that keep audiences entertained & coming back for more.",
    objectives: [
      "Delivering seamless entertainment on every platform.",
      "Combining creativity & technology for unforgettable experiences.",
      "Designing for fun, engagement, & connection.",
    ],
    href: "/industries/entertainment",
    tabImage: "entertainment.avif"
  },
  {
    tabName: "Gaming",
    tabDes:
      "Gaming is more than play – it’s an adventure. Our apps bring captivating worlds to life, blending stunning graphics & smooth gameplay. From casual games to expansive multiplayer experiences, we fuel imagination & excitement with every tap.",
    objectives: [
      "Bringing immersive gaming experiences to life.",
      "Designing for fun, competition, & connection.",
      "Perfect for players of every kind, everywhere.",
    ],
    href: "/industries/gaming",
    tabImage: "gaming.png"
  },
  {
    tabName: "Social Networking",
    tabDes:
      "Social networking is about more than connecting; it’s about creating moments that matter. Our apps let users share, collaborate, & build communities effortlessly. With intuitive designs & engaging features, we make every connection meaningful.",
    objectives: [
      "Helping people stay connected, wherever they are.",
      "Building tools for collaboration & interaction.",
      "Empowering users to create lasting digital communities.",
    ],
    href: "/industries/social-networking",
    tabImage: "social-networking.png"
  },
  {
    tabName: "Telecom",
    tabDes:
      "Telecom connects the world, & our apps are built to elevate that connection. From streamlining communication services to managing complex operations, we empower telecom providers to deliver seamless, reliable, & innovative experiences. At Bitsclan, we help services providers make networks smarter, faster, & user-centric.",
    objectives: [
      "Enabling efficient communication management.",
      "Simplifying operations with intelligent tools.",
      "Driving innovation for better connectivity.",
    ],
    href: "/industries/telecom",
    tabImage: "Telecom.png"
  },
  {
    tabName: "Energy",
    tabDes:
      "In an era of sustainability, energy management demands smarter solutions. Our apps help optimize resources, monitor usage, & streamline operations for energy providers. Whether it’s renewable energy tracking or grid management, we bring clarity & control to the power sector.",
    objectives: [
      "Revolutionizing energy monitoring & efficiency.",
      "Supporting sustainability with innovative tools.",
      "Empowering smarter energy solutions for tomorrow.",
    ],
    href: "/industries/energy",
    tabImage: "Energy.png"
  },
];
